var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"zmdi zmdi-power"})]),_c('div',{staticClass:"id"},[_vm._v(_vm._s(_vm.source.id)+" - "+_vm._s(_vm.source.item))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }